module.exports = __webpack_public_path__ + "img/2658.7e536fca.jpg";